import clsx from 'clsx'

export interface FilterChipOption {
  id: string
  label: string
  count?: number
}

export interface FilterChipsProps {
  options: FilterChipOption[]
  active: string
  onPick: (id: string) => void
}

export function FilterChips({ options, active, onPick }: FilterChipsProps) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {options.map((opt) => {
        const isActive = opt.id === active
        return (
          <button
            key={opt.id}
            type="button"
            aria-pressed={isActive}
            onClick={() => onPick(opt.id)}
            className={clsx(
              'flex h-8 items-center gap-1.5 rounded-full px-3 text-[12px] font-medium transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2563EB] focus-visible:ring-offset-1',
              isActive
                ? 'bg-[#0F172A] text-white'
                : 'border border-[rgba(15,23,42,0.07)] bg-white text-[#334155] hover:border-[rgba(15,23,42,0.16)]',
            )}
          >
            {opt.label}
            {opt.count != null ? (
              <span
                className={clsx(
                  'font-mono text-[11px] tabular-nums',
                  isActive ? 'text-white/60' : 'text-[#94A3B8]',
                )}
              >
                {opt.count}
              </span>
            ) : null}
          </button>
        )
      })}
    </div>
  )
}
